import { PLACES_KEY } from '@/services/Configuration'

export const getPlacesKey = async () => ({ placesKey: PLACES_KEY })

export const placesAPIPresent = () => !!window?.google?.maps?.places?.AutocompleteService

export const getNonShippedStates = () => []

export { getAddresses } from './getAddresses'

export { getAddressObjectFromDescription } from './getAddressObjectFromDescription'

export { getPlacesPredictions } from './getPlacesPredictions'

export { addGooglePlacesAPI } from './addGooglePlacesAPI'

export { deleteAddress } from './deleteAddress'

export { default as saveAddressToUser } from './saveAddressToUser'

export const createAddress = async () => 'ok'
export const editAddress = async () => 'ok'
export const getShipments = async () => 'ok'
